import { LoadingElement } from "@pinkyhead/dovekit"
import { LoadingContainer } from "../LoadingPlaceholders.styles"
import { Container } from "./CardLoading.styles"

export const CardLoading = () => {
  return (
    <LoadingContainer>
      <Container>
        <div className="wrapper wrapper-avatar">
          <LoadingElement width="70px" height="70px" variant="circle" />
          <LoadingElement width="88px" height="16px" />
          <LoadingElement width="60px" height="16px" />
        </div>
        <div className="wrapper">
          <LoadingElement width="60%" />
          <LoadingElement width="100px" height="22px" />
          <LoadingElement width="40px" height="14px" />
        </div>
      </Container>
    </LoadingContainer>
  )
}
